import { gql } from "@apollo/client";

export const SUBMIT_PATIENT_FEEDBACK = gql`
  mutation SubmitPatientFeedback($input: SubmitPatientFeedbackInput!) {
    submitPatientFeedback(input: $input) {
      success
    }
  }
`;

export interface SubmitPatientFeedbackVariables {
  input: {
    score: number;
    scoreReason?: string;
    generalFeedback?: string;
  };
}

export interface SubmitPatientFeedbackData {
  submitPatientFeedback: {
    success: boolean;
  };
}
